/**
 * @desc 通过调价申请单号获取详情-调价申请界面
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.ProcurementOrderAndDetailsResponseDto>;
export function request(pricingNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/procurementOrder/getDetailByPricingNo/${pricingNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
